import api from "@/lib/api";

let WA_NUMBER = "2250798647783";

export function setWaNumber(n) { if (n) WA_NUMBER = n.replace(/\D/g, ""); }
export function getWaNumber() { return WA_NUMBER; }

export function openWhatsApp({ message, page = "", solution = "", service = "", campagne = "", source = "site" } = {}) {
  const text = encodeURIComponent(
    message || "Bonjour VISION LOGICIELS, je souhaite obtenir plus d'informations."
  );
  // fire-and-forget tracking
  api.post("/whatsapp/click", { numero: WA_NUMBER, page_origine: page, solution, service, campagne, source }).catch(() => {});
  window.open(`https://wa.me/${WA_NUMBER}?text=${text}`, "_blank", "noopener");
}
